// 刃幅入力コンポーネント

interface KerfInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  touched?: boolean;
}

export function KerfInput({
  value,
  onChange,
  error,
  touched,
}: KerfInputProps) {
  const showError = error && touched;

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-900">刃幅</h3>
      
      <div className="form-group">
        <label htmlFor="kerf" className="form-label">
          刃幅 (mm)
          <span className="text-red-600 ml-1" aria-label="必須">*</span>
        </label>
        
        <div className="max-w-xs">
          <input
            type="number"
            id="kerf"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={`input-field ${showError ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}`}
            placeholder="3.2"
            min="0"
            step="0.1"
            aria-invalid={showError ? 'true' : undefined}
            aria-describedby={showError ? 'kerf-error' : 'kerf-help'}
          />
        </div>

        {showError ? (
          <div id="kerf-error" className="form-error" role="alert">
            {error}
          </div>
        ) : (
          <div id="kerf-help" className="text-sm text-gray-600 mt-1">
            切断時の刃の厚み（損失幅）を入力してください。通常は3-5mm程度です。
          </div>
        )}
      </div>

    </div>
  );
}